export interface IChatState {
  messageSid?: string | null;
  value: string;
}

export type IChatAction =
  | { type: 'open'; messageSid: string }
  | { type: 'close' }
  | { type: 'storeInput'; value: string };

export const initialReducerState: IChatState = { messageSid: null, value: '' };

export function reducer(state: IChatState, action: IChatAction): IChatState {
  switch (action.type) {
    case 'open':
      return { messageSid: action.messageSid, value: '' };
    case 'close':
      return initialReducerState;
    case 'storeInput':
      return { ...state, value: action.value };
  }
}
